<template>
  <div class="home-container">
    <h2 class="content-block">Advanced Analysis (example data)</h2>
    <div class="content-block dx-card responsive-paddings">
      <span>Day of Analysis: </span>
      <DxButton icon="chevronprev" @click="dayBackward()"/>
      <DxDateBox 
        :min="calendarOpts.minDate"
        :max="calendarOpts.maxDate"
        width="180px"
        type="date"
        v-model:value="calendarOpts.daySelected"
        display-format="d/MM/yyyy"
        @value-changed="daySelectionChange"
        style="display: inline-block;"
      />
      <DxButton icon="chevronnext" @click="dayForward()"/>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings" >
        <DxChart
          :data-source="energySourceStore"
          :legend="legendGenChart">
          <DxCommonSeriesSettings
            argument-field="hour"
            value-field="kwhProduced" 
            type="stackedbar"
            />
          <DxSeriesTemplate name-field="assetId" :customize-series="predictLineFormat" />
          <DxTooltip :enabled="true" location="edge" />
        </DxChart>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings" >
        <DxChart
          :data-source="energyLoadsStore" 
          :legend="legendConsumChart" >
          <DxSeries
            value-field="kwhConsumPred"
            name="Predict. kwh"
            type="spline"
          >
            <DxValueErrorBar
              :line-width="1"
              :opacity="0.4"
              low-value-field="kwhConsumPredMin"
              high-value-field="kwhConsumPredMax"
            />
          </DxSeries>
          <DxCommonSeriesSettings
            argument-field="hour"
            value-field="kwhConsum" 
            type="stackedbar"
            />
          <DxSeriesTemplate name-field="assetId" :customize-series="predictLineFormat" />
          <DxTooltip :enabled="true" location="edge" />
        </DxChart>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxChart
          :data-source="energyPrice" 
          :legend="legendPriceChart" >
          <DxSeries
            value-field="priceEur"
            name="Price €/kwh"
          />
          <DxCommonSeriesSettings
            argument-field="hour"
            type="area"
            />
          <DxTooltip :enabled="true" location="edge" />
        </DxChart>
      </div>
    </div>
  </div>
</template>

<script>
import DxChart, {
  DxSeries,
  DxTooltip,
  DxCommonSeriesSettings,
  DxSeriesTemplate,
  DxValueErrorBar,
} from 'devextreme-vue/chart';
import { DxDateBox } from 'devextreme-vue/date-box';
import DxButton from 'devextreme-vue/button';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { reactive } from 'vue';
import RawDataService from '../services/RawDataServiceTemplate';
import * as aq from 'arquero';


const energyPrice = [
      { "hour": 0, "priceEur": 0.16364, "day": "2021-09-21" },
      { "hour": 1, "priceEur": 0.16165, "day": "2021-09-21" },
      { "hour": 2, "priceEur": 0.15442, "day": "2021-09-21" },
      { "hour": 3, "priceEur": 0.15414, "day": "2021-09-21" },
      { "hour": 4, "priceEur": 0.15362, "day": "2021-09-21" },
      { "hour": 5, "priceEur": 0.16287, "day": "2021-09-21" },
      { "hour": 6, "priceEur": 0.18831, "day": "2021-09-21" },
      { "hour": 7, "priceEur": 0.22118, "day": "2021-09-21" },
      { "hour": 8, "priceEur": 0.2464, "day": "2021-09-21" },
      { "hour": 9, "priceEur": 0.22838, "day": "2021-09-21" },
      { "hour": 10, "priceEur": 0.22257, "day": "2021-09-21" }, 
      { "hour": 11, "priceEur": 0.21475, "day": "2021-09-21" },
      { "hour": 12, "priceEur": 0.20769, "day": "2021-09-21" },
      { "hour": 13, "priceEur": 0.19385, "day": "2021-09-21" },
      { "hour": 14, "priceEur": 0.17929, "day": "2021-09-21" },
      { "hour": 15, "priceEur": 0.1784, "day": "2021-09-21" },
      { "hour": 16, "priceEur": 0.18255, "day": "2021-09-21" },
      { "hour": 17, "priceEur": 0.20195, "day": "2021-09-21" },
      { "hour": 18, "priceEur": 0.23366, "day": "2021-09-21" },
      { "hour": 19, "priceEur": 0.25676, "day": "2021-09-21" },
      { "hour": 20, "priceEur": 0.25938, "day": "2021-09-21" },
      { "hour": 21, "priceEur": 0.25534, "day": "2021-09-21" },
      { "hour": 22, "priceEur": 0.22141, "day": "2021-09-21" },
      { "hour": 23, "priceEur": 0.1875, "day": "2021-09-21" },
    ];

    const energyLoads = [
      { hour: 0, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.4 },
      { hour: 1, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.1 },
      { hour: 2, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.1 },
      { hour: 3, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.1 },
      { hour: 4, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.1 },
      { hour: 5, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.15, "kwhConsumPred": 0.18, "kwhConsumPredMin": 0.15, "kwhConsumPredMax": 0.21 },
      { hour: 6, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.1, "kwhConsumPred": 0.12, "kwhConsumPredMin": 0.10, "kwhConsumPredMax": 0.13 },
      { hour: 7, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.12, "kwhConsumPred": 0.12, "kwhConsumPredMin": 0.11, "kwhConsumPredMax": 0.13 },
      { hour: 8, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.35, "kwhConsumPred": 0.4, "kwhConsumPredMin": 0.18, "kwhConsumPredMax": 0.53 },
      { hour: 9, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.55, "kwhConsumPred": 0.52, "kwhConsumPredMin": 0.40, "kwhConsumPredMax": 0.55 },
      { hour: 10, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.15, "kwhConsumPred": 0.15, "kwhConsumPredMin": 0.15, "kwhConsumPredMax": 0.33 },
      { hour: 11, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.1, "kwhConsumPred": 0.13, "kwhConsumPredMin": 0.11, "kwhConsumPredMax": 0.16 },
      { hour: 12, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.1, "kwhConsumPred": 0.12, "kwhConsumPredMin": 0.10, "kwhConsumPredMax": 0.13 },
      { hour: 13, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.15, "kwhConsumPred": 0.16 },
      { hour: 14, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.35 },
      { hour: 15, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.35 },
      { hour: 16, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.3 },
      { hour: 17, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.3 },
      { hour: 18, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.3 },
      { hour: 19, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.48 },
      { hour: 20, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.52 },
      { hour: 21, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.59 },
      { hour: 22, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.51 },
      { hour: 23, assetId: "A701_LoadDemmand", "day": "2021-09-21", "kwhConsum": 0.45 },
      { hour: 5, assetId: "forecast", "day": "2021-09-21", "kwhConsum": 0.18, "kwhConsumPredMin": 0.15, "kwhConsumPredMax": 0.21 },
      { hour: 6, assetId: "forecast", "day": "2021-09-21", "kwhConsum": 0.12, "kwhConsumPredMin": 0.10, "kwhConsumPredMax": 0.13 },
      { hour: 7, assetId: "forecast", "day": "2021-09-21", "kwhConsum": 0.12, "kwhConsumPredMin": 0.11, "kwhConsumPredMax": 0.13 },
      { hour: 8, assetId: "forecast", "day": "2021-09-21", "kwhConsum": 0.4, "kwhConsumPredMin": 0.18, "kwhConsumPredMax": 0.53 },
      { hour: 9, assetId: "forecast", "day": "2021-09-21", "kwhConsum": 0.52, "kwhConsumPredMin": 0.40, "kwhConsumPredMax": 0.55 },
      { hour: 10, assetId: "forecast", "day": "2021-09-21", "kwhConsum": 0.15, "kwhConsumPredMin": 0.15, "kwhConsumPredMax": 0.33 },
      { hour: 11, assetId: "forecast", "day": "2021-09-21", "kwhConsum": 0.13, "kwhConsumPredMin": 0.11, "kwhConsumPredMax": 0.16 },
      { hour: 12, assetId: "forecast", "day": "2021-09-21", "kwhConsum": 0.12, "kwhConsumPredMin": 0.10, "kwhConsumPredMax": 0.13 },
      { hour: 13, assetId: "forecast", "day": "2021-09-21", "kwhConsum": 0.16 },
    ];

    //TODO: delete static init source
    const energySources = [
      { assetId: "Solar 1", hour: 0, kwhProduced: 0 },
      { assetId: "Solar 1", hour: 1, kwhProduced: 0 },
      { assetId: "Solar 1", hour: 2, kwhProduced: 0 },
      { assetId: "Solar 1", hour: 3, kwhProduced: 0 },
      { assetId: "Solar 1", hour: 4, kwhProduced: 0 },
      { assetId: "Solar 1", hour: 5, kwhProduced: 0 },
      { assetId: "Solar 1", hour: 6, kwhProduced: 0 },
      { assetId: "Solar 1", hour: 7, kwhProduced: 9 },
      { assetId: "Solar 1", hour: 8, kwhProduced: 18 },
      { assetId: "Solar 1", hour: 9, kwhProduced: 28 },
      { assetId: "Solar 1", hour: 10, kwhProduced: 75 },
      { assetId: "Solar 1", hour: 11, kwhProduced: 79 },
      { assetId: "Solar 1", hour: 12, kwhProduced: 90 },
      { assetId: "Solar 1", hour: 13, kwhProduced: 90 },
      { assetId: "Solar 1", hour: 14, kwhProduced: 84 },
      { assetId: "Solar 1", hour: 15, kwhProduced: 82 },
      { assetId: "Solar 1", hour: 16, kwhProduced: 90 },
      { assetId: "Solar 1", hour: 17, kwhProduced: 84 },
      { assetId: "Solar 1", hour: 18, kwhProduced: 82 },
      { assetId: "Solar 1", hour: 19, kwhProduced: 41 },
      { assetId: "Solar 1", hour: 20, kwhProduced: 14 },
      { assetId: "Solar 1", hour: 21, kwhProduced: 2 },
      { assetId: "Solar 1", hour: 22, kwhProduced: 0 },
      { assetId: "Solar 1", hour: 23, kwhProduced: 0 },
      { assetId: "Solar 2", hour: 11, kwhProduced: 7 },
      { assetId: "Solar 2", hour: 12, kwhProduced: 17 },
      { assetId: "Solar 2", hour: 13, kwhProduced: 27 },
      { assetId: "Solar 2", hour: 14, kwhProduced: 30 },
      { assetId: "Solar 2", hour: 15, kwhProduced: 29 },
      { assetId: "Solar 2", hour: 16, kwhProduced: 27 },
      { assetId: "Solar 2", hour: 17, kwhProduced: 6 },

      { assetId: "forecast", hour: 9, kwhProduced: 5.5 },
      { assetId: "forecast", hour: 10, kwhProduced: 18.5 },
      { assetId: "forecast", hour: 11, kwhProduced: 36.7 },
      { assetId: "forecast", hour: 12, kwhProduced: 90.5 },
      { assetId: "forecast", hour: 13, kwhProduced: 186.6 },
      { assetId: "forecast", hour: 14, kwhProduced: 250.5 },
      { assetId: "forecast", hour: 15, kwhProduced: 255.3 },
      { assetId: "forecast", hour: 16, kwhProduced: 252.8 },
      { assetId: "forecast", hour: 17, kwhProduced: 170.5 },
      { assetId: "forecast", hour: 18, kwhProduced: 35.5 },
    ];


export default {
  components: {
    DxChart,
    DxSeries,
    DxTooltip,
    DxCommonSeriesSettings,
    DxSeriesTemplate,
    DxValueErrorBar,
    DxDateBox,
    DxButton,
  },
  setup() {
    const today = new Date();
    const calendarOpts = reactive({ 
      minDate: new Date(2020, 0, 1), 
      maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()+1) , 
      daySelected: new Date(today.getFullYear(), today.getMonth(), today.getDate()) 
    });

    //TODO: delete firstload
    let firstLoad = true;

    const energySourceStore = new DataSource({
      store: new CustomStore({
        load: async () => {
          if (firstLoad){ //TODO: to delete on first load
            return energySources;
          } 
          powerGenDataService.setFilter({dateStart: calendarOpts.daySelected});
          powerGenGridService.setFilter({dateStart: calendarOpts.daySelected});
            const [dataPGen, dataPGrid] = await Promise.all([
            powerGenDataService.getAll(),
            powerGenGridService.getAll(),
          ]);
          const t1 = aq.from(dataPGen,['Asset', 'W_avg', 'time']).rename({Asset: 'assetId'}).derive({ kwhProduced: d => d.W_avg/1000});
          const t2 = aq.from(dataPGrid,['Asset', 'W_avg', 'time']).rename({Asset: 'assetId'}).derive({ kwhProduced: d => d.W_avg/1000});
          return t1.union(t2)
          .derive({ dateObj: d => aq.op.parse_date(d.time) })
          .derive({ hour: d => aq.op.hours(d.dateObj) })
          .objects();
        }
      }),
      paginate: false
    });

    const energyLoadsStore = new DataSource({
      store: new CustomStore({
        load: async () => {
          if (firstLoad){ //TODO: to delete on first load
            firstLoad = false;
            return energyLoads;
          } 
          powerConsum1DS.setFilter({dateStart: calendarOpts.daySelected});
          powerConsum2DS.setFilter({dateStart: calendarOpts.daySelected});
            const [dataLoad1, dataLoad2] = await Promise.all([
            powerConsum1DS.getAll(),
            powerConsum2DS.getAll(),
          ]);
          const t3 = aq.from(dataLoad1,['Asset', 'W_avg', 'time']).rename({Asset: 'assetId',}).derive({ kwhConsum: d => d.W_avg/1000 });
          const t4 = aq.from(dataLoad2,['Asset', 'W_avg', 'time']).rename({Asset: 'assetId',}).derive({ kwhConsum: d => d.W_avg/1000 });
          return t3.union(t4)
          .derive({ dateObj: d => aq.op.parse_date(d.time) })
          .derive({ hour: d => aq.op.hours(d.dateObj) }) 
          .objects();
        }
      }),
      paginate: false
    });

    const powerGenDataService = new RawDataService(`assets/A701_PVGeneration/signalStorage/W`);
    const powerGenGridService = new RawDataService(`assets/A701_GridSideDemmand/signalStorage/W`);
    const powerConsum1DS = new RawDataService(`assets/A701_LoadDemmand/signalStorage/W`);
    const powerConsum2DS = new RawDataService(`assets/A701_LoadDemmand2/signalStorage/W`);

    const predictLineFormat = (seriesName) => {
      return seriesName === 'forecast' ? { 
        type: 'spline', 
        ignoreEmptyPoints: true,
        label: { visible: true }, 
        valueErrorBar:{
          lineWidth: 1,
          opacity: 0.4,
          lowValueField: "kwhConsumPredMin", //TODO: make relative to seriesName I.e seriesName+'_fc_max'
          highValueField: "kwhConsumPredMax",
        }
        //color: '#ff3f7a' 
        }: {};
    }

    const legendGenChart = reactive({
      visible: true,
      horizontalAlignment: 'center',
      verticalAlignment: 'top',
      title: 'Energy Sources (Kwh)'
    });
    const legendPriceChart = reactive({
      visible: true,
      horizontalAlignment: 'center',
      verticalAlignment: 'top',
      title: 'Grid Energy Cost'
    });
    const legendConsumChart = reactive({
      visible: true,
      horizontalAlignment: 'center',
      verticalAlignment: 'top',
      title: 'Energy Consumption (Kwh)'
    });

    const daySelectionChange = () => {
      energySourceStore.reload();
      energyLoadsStore.reload();
    }

    const dayForward = () => {
      const dayEval = calendarOpts.daySelected;
      calendarOpts.daySelected = new Date(dayEval.getFullYear(), dayEval.getMonth(), dayEval.getDate()+1);
    }
    const dayBackward = () => {
      const dayEval = calendarOpts.daySelected;
      calendarOpts.daySelected = new Date(dayEval.getFullYear(), dayEval.getMonth(), dayEval.getDate()-1);
    }

    return {
      energySourceStore,
      energyLoadsStore,
      dayForward,
      dayBackward,

      predictLineFormat,
      legendGenChart,
      legendPriceChart,
      legendConsumChart,
      energyPrice,
      calendarOpts,
      daySelectionChange,
    }
  },
}
</script>

<style lang="scss">
.home-container {
  max-width: 1350px;
  margin: 0 auto;
}
</style>
